import { AxiosResponse } from 'axios';
import { IOrderRequestsResponse } from '../types/api/orderRequestsApi';
import { getAuthToken } from '../utils/commonHelper';
import { ITableRequestData } from '../types/common';
import axiosInstance from '../utils/AxiosInstance';

const API_URL = `${process.env.REACT_APP_API_URL}/order`; // Replace with your actual API URL


const customHeaders = {
    'content-type': 'application/json',
};

export const getOrderRequestsDataService = async ({ limit, page, status }: ITableRequestData): Promise<AxiosResponse<IOrderRequestsResponse>> => {
    try {
        let url = `${API_URL}/saved/all`;

        if (limit !== undefined && page !== undefined) url += `?limit=${limit}&page=${page}`;

        if (status && status !== 'all') url += `&status=${status}`;

        const response = await axiosInstance.get(url, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const getOrderRequestDetailService = async ({ id }: { id: string }): Promise<AxiosResponse<IOrderRequestsResponse>> => {
    try {
        let url = `${API_URL}/saved/${id}`;
        const response = await axiosInstance.get(url, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const updateOrderRequestDetailService = async ({ id, data }: { id: string, data: any }): Promise<AxiosResponse<IOrderRequestsResponse>> => {
    try {
        let url = `${API_URL}/${id}?is_admin=true`;
        const response = await axiosInstance.put(url, data, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const postOrderToSapService = async ({ data,id }: { data: any,id: string }) => {
    try {
        let url = `${process.env.REACT_APP_API_URL}/sap/create-sap-order/${id}`;

        const response = await axiosInstance.post(url, data, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
}


